module.exports = __webpack_public_path__ + "img/photo01.3c5ccb34.jpg";